export const MODULE = 'Module';
export const MODULE_INSTANCE = 'ModuleInstance';
export const ORGANIZATION_MODULE = 'OrganizationModule';
export const THEME_SETTING = 'ThemeSetting';
/** Where a module has a programmed screen. Spec 0038 §3.1 / request 0151. */
export const MODULE_PLATFORMS = ['console', 'mobile'];
//# sourceMappingURL=module.js.map